import React, { useState, useEffect } from 'react';
import { getViolationStatus } from '../../../common/apiService'
import Table from 'react-bootstrap/Table'
import Loader from 'react-loader-spinner'


export default function RejectedViolationStatus({ jsonData, setChartRejviolance }) {
    const [rejviolance, setRejviolance] = useState([])
    const [width, setWidth] = useState("");
    const [loading, setLoading] = useState(false);

    const getData = async () => {
        setLoading(true);
        try{
        const plazaIds = Array.isArray(jsonData.plazaIds) ? jsonData.plazaIds.join(",") : jsonData.plazaIds; 
        jsonData.plazaIds = plazaIds;
        const { data } = await getViolationStatus(jsonData);
        let grid = [];
        let sumData = [];
        setLoading(false);
        for (let d of data) {
            if(d.remarks !== null) {
            const seg = d.remarks.substring(0, 25) + "...";
            const json = {
                lable: seg,
                segment: d.remarks,
                count: d.cases,
                sum: d.sumAmount
            }
            grid.push(json);
            sumData.push(json.count); }
        }
        const sumRejCount = sumData.reduce((a, v) => a = a + v, 0);

        const gridDashboard = [];
        grid.forEach((element, index) => {
            const json = {
                lable: element.lable,
                segment: element.segment,
                count: parseFloat((element.count / sumRejCount * 100).toFixed(2)),
                sum: element.sum
            }
            gridDashboard.push(json);
        });
        let cache = [];
        grid.forEach((e,i)=>{
              cache.push(e);
              setRejviolance([...cache]);
        })
          if(grid.length===0){
            setRejviolance([]);
          }
        //   setRejviolance(grid);
        setChartRejviolance(gridDashboard)
        setWidth(65);
        } catch {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (jsonData.plazaIds != null && jsonData.startDate && jsonData.endDate)
            getData();
        // eslint-disable-next-line
    }, [jsonData]);


   
    
    return (
        <div className="s-violance">
            <Loader className="loader"
                type="ThreeDots"
                color="#9c1d26"
                height={100}
                width={100}
                visible={loading}
            />
            <p className="rjvstatus">Rejected Violations Status</p><br />
            <div style={{ height: 400, overflowY: 'auto' ,overflowX:'hidden'}}>
            {loading ? '' : <>
            {rejviolance.length  > 0 ?
               <Table striped bordered hover className="customTable table">
                    <thead>
                        <tr style={{ position: 'sticky', top: 0 }}>
                            <th width={width + "%"}> &nbsp; &nbsp; Segment</th>
                            <th>Count</th>
                            <th>Sum(&#8377;)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rejviolance.length > 0 ?
                            rejviolance.map(e => {
                                return (
                                    <tr>
                                        <td> &nbsp; &nbsp; {e.segment}</td>
                                        <td>{e.count}</td>
                                        <td>&#8377;{e.sum}</td>
                                    </tr>
                                );
                            })
                            :
                            <tr>
                                <td colSpan="3" style={{textAlign:'center',border:'none'}}>Data Not Found!</td>
                            </tr>
                        }
                    </tbody>
                </Table>
                    : <h1 className="no-record" style={{marginTop:110}}>Record Not Found</h1> } </>} 
            </div>
        </div>
    )
}
